import { useEffect, useState } from "react"
import { useFormContext } from "react-hook-form"
import { Grid } from "@mui/material"
import { Dropdown } from "components/fields"
import { useForms } from "hooks"
import { usePrevious } from "hooks/usePrevious"

const Programme = () => {

  const { control, setValue, watch } =useFormContext()
  const { componentFetched, recordTypeId, salesforce, setComponentStates, setOpenSnackbar, setSnackMessage } = useForms()
  // const campus = watch('lead.Campus__c')
  // const academicLevel = watch('lead.AcademicLevel__c')
  // const watchCursus = watch('cursus')
  const watchCycle = watch('cycle')
  const previousCycle = usePrevious(watchCycle)
  // const watchCampus = watch('lead.Campus__c')
  const [optionsProgramme, setOptionsProgramme] = useState([])
  const [specialities, setSpecialities] = useState([])

  useEffect(() => {
    if (recordTypeId !== '' && watchCycle !== '' && previousCycle === '') {
      const getData = async () => {
        const specialities = await salesforce.getSpecialities('e-artsup')
        return { specialities }
      }

      getData().then((value) => {
        const { specialities } = value
        setSpecialities(specialities)
      }).catch((error) => {
        setOpenSnackbar(true)
        console.log('erreur', error)
        setSnackMessage('Une erreur est survenue lors du chargement du formulaire')
      })
    }
  }, [previousCycle, recordTypeId, watchCycle])

  useEffect(() => {
    if (watchCycle !== '' && specialities.length > 0) {
      let finalSpecialities = Array.from(
        new Map(
          specialities
            .filter(el => el.Session__r.LearningProgram__r.Cycle__c === watchCycle)
            .map(el => [el.Speciality__c, {
              label: el.Speciality__r.Name,
              value: el.Speciality__c
            }])
        ).values()
      )
      const hesite = {
        label: `J'hésite encore !`,
        value: 'hesite',
      }
      finalSpecialities.push(hesite)
      setOptionsProgramme(finalSpecialities)
    }
  }, [specialities, watchCycle])

  useEffect(() => {
    if (previousCycle !== watchCycle) {
      setValue('lead.Speciality__c', '')
      if (watchCycle === '') {
        setOptionsProgramme([])
      }
    }
  }
  , [watchCycle, previousCycle])

  return (
    <>
      {optionsProgramme.length > 0 && (
        <Grid item xs={12}>
          <Dropdown control={control} disabled={watchCycle === ''} label={`Programme d'intérêt`} name="lead.Speciality__c" options={optionsProgramme} required />
        </Grid>
      )}
    </>
  )
}

export default Programme
